import Icon from "@components/Atoms/Icon";
import useMediaQuery from "@core-ui/hooks/useMediaQuery";
import { cssMedia } from "@core-ui/utils/cssUtils";
import t from "@ext/localization/locale/translate";
import { TemplatePickerItems } from "@ext/templates/components/TemplatePicker/TemplatePickerItems";
import { useTemplatePicker } from "@ext/templates/components/TemplatePicker/useTemplatePicker";
import { DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from "@ui-kit/Dropdown";

const TemplateItemList = ({ itemRefPath }: { itemRefPath: string }) => {
	const picker = useTemplatePicker(itemRefPath);
	const isMobile = useMediaQuery(cssMedia.JSnarrow);

	return (
		<DropdownMenuSub onOpenChange={picker.onOpenChange}>
			<DropdownMenuSubTrigger>
				<div className="flex items-center gap-2" data-testid="templates-menu">
					<Icon code="layout-template" />
					{t("template.choose-template")}
				</div>
			</DropdownMenuSubTrigger>
			<DropdownMenuSubContent
				alignOffset={!isMobile ? -18 : 0}
				className="flex max-w-[min(20rem,var(--radix-dropdown-menu-content-available-width,100%))] flex-col"
				onFocusOutside={picker.handleFocusOutside}
				onKeyDown={picker.handleContentKeyDown}
				ref={picker.contentRef}
				sideOffset={!isMobile ? 2 : 6}
			>
				<TemplatePickerItems picker={picker} />
			</DropdownMenuSubContent>
		</DropdownMenuSub>
	);
};

export default TemplateItemList;
